module.exports = __webpack_public_path__ + "static/img/5.40ad161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/5.png
// module id = SUUm
// module chunks = 0